// extracted by mini-css-extract-plugin
module.exports = {"circle":"Index_circle__Ma_rR","center":"Index_center__7G0Ah","close":"Index_close__WeIdu","text":"Index_text__kBJIv"};